const endpointMap = new Map([

    // AUTH
    ["login", "auth/login"],
    ["recoverpass","auth/recoverpassword"],
    ["setpassword","auth/setpassword"],
    ["refreshtoken","auth/refreshtoken"],
    ["tester","user/gettest"],
    ["getuser","user/getuser"],
    ["adduser","user/adduser"],
    ["edituser","user/edituser"],
    ["getroles","user/getroles"],
    ["getrole","user/getrole"],
    ["addrole","user/addrole"],
    ["editrole","user/editrole"],
    // ["clientsearch","Users/clientsearch"],
    ["clientsearch","Users/clientsearch"],
    ["tree","user/tree"],
    ["events","user/events"],
    ["rec","user/rec",],
    ["emaildetails","user/emaildetails"],
    ["emailrec","user/emailrecipients"],
    ["email","user/GetEmail",],
    ["editemail","user/editemail"],
    ["addemail","user/addemail"],
    ["emailvars","user/emailvars"],
    ["Users","Users"],
    ["GetUser","Users/get"],
    ["AddUser","Users/add"],
    ["UpdateUser","Users/update"],
    ["LockUnlockUser","Users/lock"],
    ["ResendInvite","Users/resend"],
    ["Roles","Roles"],
    ["GetRole","Roles/get"],
    ["AddRole","Roles/add"],
    ["UpdateRole","Roles/update"],
    ["Permissions","Permissions"],
    ["AudienceMemberships","AudienceMemberships"],
    ["Documents","Documents"],
    ["AddDocuments","Documents/add"],
    ["GetDocument","Documents/get"],
    ["DeleteDocument","Documents/delete"],
    ["ClientSearch","Client/search"],
    ["ClientInformation","Client/info"],
    ["ClientInformationExpanded","Client/infoexpanded"],
    ["GetApplications","Applications/get"],
    ["AddApplication","Applications/add"],
    ["NoteDefinitions","Notes/definitions"],
    ["CaseManagementNotes","Notes/CaseManagementNotes"],
    ["CaseManagementNote","Notes/CaseManagementNotes/get"],
    ["AddCaseManagementNote","Notes/CaseManagementNotes/add"],
    ["UpdateCaseManagementNote","Notes/CaseManagementNotes/update"],
    ["HDINotes","Notes/HDINotes"],
    ["HDINote","Notes/HDINotes/get"],
    ["AddHDINote","Notes/HDINotes/add"],
    ["UpdateHDINote","Notes/HDINotes/update"],
    ["HousingNotes","Notes/HousingNotes"],
    ["HousingNote","Notes/HousingNotes/get"],
    ["AddHousingNote","Notes/HousingNotes/add"],
    ["UpdateHousingNote","Notes/HousingNotes/update"],
    ["TransitionPlan","Applications/TransitionPlan"],
    ["UpdateTransitionPlan","Applications/TransitionPlan/update"],
    ["Needs","Applications/TransitionPlan/Needs"],
    ["Need","Applications/TransitionPlan/Needs/get"],
    ["AddNeed","Applications/TransitionPlan/Needs/add"],
    ["UpdateNeed","Applications/TransitionPlan/Needs/update"],
    ["DeleteNeed","Applications/TransitionPlan/Needs/delete"],
    ["NeedTypesCat","Applications/TransitionPlan/Needs/definitions"],
    ["Goal","Applications/TransitionPlan/Goals/get"],
    ["AddGoal","Applications/TransitionPlan/Goals/add"],
    ["UpdateGoal","Applications/TransitionPlan/Goals/update"],
    ["DeleteGoal","Applications/TransitionPlan/Goals/delete"],
    ["Service","Applications/TransitionPlan/Services/get"],
    ["AddService","Applications/TransitionPlan/Services/add"],
    ["UpdateService","Applications/TransitionPlan/Services/update"],
    ["DeleteService","Applications/TransitionPlan/Services/delete"],
    ["ServiceTypes","Applications/TransitionPlan/Services/definitions"],
    ["Provider","Applications/TransitionPlan/Providers/get"],
    ["AddProvider","Applications/TransitionPlan/Providers/add"],
    ["UpdateProvider","Applications/TransitionPlan/Providers/update"],
    ["DeleteProvider","Applications/TransitionPlan/Providers/delete"],
    ["ProviderTypes","Applications/TransitionPlan/Providers/definitions"],
    ["ExpenditureWorksheet","Applications/ExpenditureWorksheet/get"],
    ["ExpenditureWorksheetDefinitions","Applications/ExpenditureWorksheet/definitions"],
    ["ExpenditureWorksheet_Procard_Get","Applications/ExpenditureWorksheet/procard/get"],
    ["ExpenditureWorksheet_Procard_FileDownload","Applications/ExpenditureWorksheet/procard/files"],
    ["ExpenditureWorksheet_Procard_Add","Applications/ExpenditureWorksheet/procard/add"],
    ["ExpenditureWorksheet_Procard_Update","Applications/ExpenditureWorksheet/procard/update"],
    ["ExpenditureWorksheet_Procard_Delete","Applications/ExpenditureWorksheet/procard/delete"],
    ["ExpenditureWorksheet_Check_Get","Applications/ExpenditureWorksheet/check/get"],
    ["ExpenditureWorksheet_Check_FileDownload","Applications/ExpenditureWorksheet/check/files"],
    ["ExpenditureWorksheet_Check_Add","Applications/ExpenditureWorksheet/check/add"],
    ["ExpenditureWorksheet_Check_Update","Applications/ExpenditureWorksheet/check/update"],
    ["ExpenditureWorksheet_Check_Delete","Applications/ExpenditureWorksheet/check/delete"],
    ["ExpenditureWorksheet_Refund_Get","Applications/ExpenditureWorksheet/refund/get"],
    ["ExpenditureWorksheet_Refund_FileDownload","Applications/ExpenditureWorksheet/refund/files"],
    ["ExpenditureWorksheet_Refund_Add","Applications/ExpenditureWorksheet/refund/add"],
    ["ExpenditureWorksheet_Refund_Update","Applications/ExpenditureWorksheet/refund/update"],
    ["ExpenditureWorksheet_Refund_Delete","Applications/ExpenditureWorksheet/refund/delete"],
    ["TransitionChecklist_Definitions","Applications/TransitionChecklist/definitions"],
    ["TransitionChecklist","Applications/TransitionChecklist"],
    ["TransitionChecklist_Update","Applications/TransitionChecklist/update"],
    ["TransitionChecklist_Procard_Add","Applications/TransitionChecklist/procard/add"],
    ["TransitionChecklist_Procard_Update","Applications/TransitionChecklist/procard/update"],
    ["CostEstimate","Applications/CostEstimate"],
    ["CostEstimate_Definitions","Applications/CostEstimate/definitions"],
    ["CostEstimate_OneTime","Applications/CostEstimate/OneTime"],
    ["CostEstimate_OneTime_Add","Applications/CostEstimate/OneTime/add"],
    ["CostEstimate_OneTime_Update","Applications/CostEstimate/OneTime/update"],
    ["CostEstimate_OneTime_Delete","Applications/CostEstimate/OneTime/delete"],
    ["CostEstimate_Service","Applications/CostEstimate/Service"],
    ["CostEstimate_Service_Add","Applications/CostEstimate/Service/add"],
    ["CostEstimate_Service_Update","Applications/CostEstimate/Service/update"],
    ["CostEstimate_Service_Delete","Applications/CostEstimate/Service/delete"],
    ["CostEstimate_Supply","Applications/CostEstimate/Supply"],
    ["CostEstimate_Supply_Add","Applications/CostEstimate/Supply/add"],
    ["CostEstimate_Supply_Update","Applications/CostEstimate/Supply/update"],
    ["CostEstimate_Supply_Delete","Applications/CostEstimate/Supply/delete"],
    ["ApplicationStatusTypes","ApplicationStatusTypes"],
    ["ApplicationStatus","Applications/Status"],
    ["GetApplicationStatus","Applications/Status/get"],
    ["ApplicationStatusDefinitions","Applications/Status/definitions"],
    ["ApplicationStatusAdd","Applications/Status/add"],
    ["ApplicationStatusUpdate","Applications/Status/update"],
    ["ApplicationStatusVoid","Applications/Status/void"],
    ["ApplicationFormDefinitions","Applications/definitions"],
    ["ApplicationForm","Applications/applicationform"],
    ["UpdateApplicationForm","Applications/update"],
    ["HousingDefinitions","Housing/definitions"],
    ["Housing","Housing"],
    ["UpdateHousingFundingTypes","Housing/updatefundingtypes"],
    ["Property","Housing/property"],
    ["UpdateProperty","Housing/updateproperty"],
    ["DownloadBidInspectionFile","Housing/downloadsubfile"],
    ["DownloadPropertyFiles","Housing/downloadprimaryfile"],
    ["FaceSheetDefinitions","Applications/FaceSheet/definitions"],
    ["FaceSheet","Applications/FaceSheet"],
    ["UpdateFaceSheet","Applications/FaceSheet/update"],
    ["ApplicationStatusesRoleDefintions","ApplicationStatusesRoles/definitions"],
    ["ApplicationStatusesRole","ApplicationStatusesRoles"],
    ["UpdateApplicationStatusesRole","ApplicationStatusesRoles/update"],
    ["Links","Links"],
    ["UpdateLinks","Links/update"],
    ["PDSDefinitions","Applications/PDS/definitions"],
    ["PDSGetAll","Applications/PDS"],
    ["PDSEntry","Applications/PDS/get/"],
    ["AddPDS","Applications/PDS/add"],
    ["UpdatePDS","Applications/PDS/update"],
    ["DeletePDS","Applications/PDS/delete"],
    ["Definitions","Definitions"],
    ["testzzz","test/a"]
    
]); 

export default endpointMap;
